import type { BlockQuote } from 'shared-types';

type LocaleData = BlockQuote['locales'][string];

const defaultBlockData = {
  format: 'html' as const
};

const translatable: LocaleData['translatable'] = {
  attribution: '',
  text: '<p></p>'
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  attribution: '{{ locales.translatable.attribution }}' as const,
  text: '{{ locales.translatable.text }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockQuoteData: BlockQuote = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockQuote['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
